import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, css, useTheme } from 'styled-components';
import Icons from '../../Elements/Icons';
export const ActionGroup = styled.div `
  display: flex;
  align-items: center;
`;
const ActionButton = styled.button `
  cursor: pointer;
  width: 24px;
  height: 24px;
  line-height: 0;
  background: none;
  border: none;
  outline: none;
  box-shadow: none;
  margin: auto;
  padding: 3px;
`;
const Message = styled.div `
  ${({ theme }) => theme.typography.textMedium}
`;
const Title = styled.div `
  ${({ theme }) => theme.typography.textLarge}
  ${({ theme }) => theme.typography.weightMedium}
`;
const Body = styled.div `
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
`;
const Icon = styled.div `
  position: absolute;
  top: 14px;
  left: 24px;
  width: 24px;
  height: 24px;
  line-height: 0;
`;
const Wrapper = styled.div `
  position: relative;
  min-height: 54px;
  width: 100%;
  padding: 15px 15px 15px 64px;
  color: rgb(0 0 0 / 65%);
  border-radius: 3px;
  ${({ $styled: { type }, theme }) => type === 'success' &&
    css `
      background-color: ${theme.colors.positive10};
      border: 1px solid ${theme.colors.positive30};
      color: ${theme.colors.positive120};
    `}
  ${({ $styled: { type }, theme }) => type === 'info' &&
    css `
      background-color: ${theme.colors.link10};
      border: 1px solid ${theme.colors.link30};
      color: ${theme.colors.link120};
    `}
  ${({ $styled: { type }, theme }) => type === 'warning' &&
    css `
      background-color: ${theme.colors.warning10};
      border: 1px solid ${theme.colors.warning30};
      color: ${theme.colors.warning120};
    `}
  ${({ $styled: { type }, theme }) => type === 'error' &&
    css `
      background-color: ${theme.colors.critical10};
      border: 1px solid ${theme.colors.critical30};
      color: ${theme.colors.critical120};
    `}
  ${({ $styled: { spacer, spacerSize } }) => spacer === 'top' &&
    css `
      margin-top: ${spacerSize ? `${spacerSize}px` : '15px'};
    `}
  ${({ $styled: { spacer, spacerSize } }) => spacer === 'bottom' &&
    css `
      margin-bottom: ${spacerSize ? `${spacerSize}px` : '15px'};
    `}
`;
const Alert = ({ reFetch, type, title, message, onClose, spacer, spacerSize, ...other }) => {
    const { colors } = useTheme();
    return (_jsxs(Wrapper, { $styled: {
            type,
            spacer,
            spacerSize,
        }, ...other, children: [_jsxs(Icon, { children: [type === 'success' && _jsx(Icons.Success, { color: colors.positive120 }), type === 'info' && _jsx(Icons.Info, { color: colors.link120 }), type === 'warning' && _jsx(Icons.Warning, { color: colors.warning120 }), type === 'error' && _jsx(Icons.Error, { color: colors.critical120 })] }), _jsxs(Body, { children: [_jsxs("div", { children: [title && _jsx(Title, { children: title }), message && _jsx(Message, { children: message })] }), (reFetch || onClose) && (_jsxs(ActionGroup, { children: [reFetch && (_jsx(ActionButton, { onClick: reFetch, type: 'button', children: _jsx(Icons.Reload, { size: 14 }) })), onClose && (_jsx(ActionButton, { onClick: onClose, type: 'button', children: _jsx(Icons.Close, { size: 14, color: colors.black_3 }) }))] }))] })] }));
};
export default Alert;
